<script lang="ts">
	import {
		CircleWithAdd,
		CircleWithDelete,
		CircleWithWarning,
	} from "@hitit/new_ui";
	import DragAndDrop from "../../../components/DragAndDrop.svelte";
	import { t } from "@hitit/hub/src/stores";
	import { createEventDispatcher } from "svelte";
	import { resizedSRC } from "@hitit/hub/src/utils/string";
	import {
		DELETE_MAIN_IMAGE,
		UPDATE_MAIN_IMAGE,
	} from "../../../functions/place/constants";

	//Props
	export let src: string = "";
	export let editMode = false;

	let containerHover = false;
	let deleteHover = false;
	$: placeHolderImage = editMode ? CircleWithAdd : CircleWithWarning;
	$: placeHolder = editMode
		? "hub.place.main_image.Add_main_image"
		: "hub.place.main_image.No_main_image";
	$: deleteFillProps = deleteHover ? "#f66d6c" : "#6d6f76";

	const dispatch = createEventDispatcher();

	function deleteImage() {
		deleteHover = false;
		dispatch(DELETE_MAIN_IMAGE);
	}

	function fileUpdateHandler(e: { detail: File }) {
		const file = e.detail;
		const extMatch = file.name.match(
			/(\.png|\.jpg|\.jpeg|\.JPG|\.JPEG|\.PNG)$/
		);
		if (!extMatch) return;
		const ext = extMatch[1].replace(".", "");
		dispatch(UPDATE_MAIN_IMAGE, {
			file: file,
			name: file.name,
			type: ext.toUpperCase(),
		});
	}

</script>

<DragAndDrop
	on:file-update={fileUpdateHandler}
	let:enter
	preventUploadfile={!editMode}>
	<div
		class="container"
		class:editMode
		on:mouseleave={() => (containerHover = false)}
		on:mouseenter={() => (containerHover = true)}>
		{#if src}
			<img
				src={resizedSRC(src, [1920, 1080])}
				style="object-fit: cover;"
				alt="main" />
			{#if editMode}
				<div
					class="delete"
					on:click|stopPropagation={deleteImage}
					on:mouseenter={() => (deleteHover = true)}
					on:mouseleave={() => (deleteHover = false)}>
					<CircleWithDelete trashPathFill={deleteFillProps} />
				</div>
			{/if}
		{:else}
			<div class="placeholder-image">
				<svelte:component
					this={placeHolderImage}
					fill={placeHolderImage === CircleWithAdd && (containerHover || enter) ? '#6591fa' : '#6d6f76'} />
			</div>
			<span>{$t(placeHolder)}</span>
		{/if}
		<div class="gradient" />
	</div>
</DragAndDrop>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		position: relative;
		background-color: #e6e7ed;

		.placeholder-image {
			width: 40px;
			height: 40px;
		}

		&.editMode {
			cursor: pointer;
		}

		.gradient {
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			position: absolute;
			background: linear-gradient(
				180deg,
				rgba(255, 255, 255, 0) 75%,
				rgba(255, 255, 255, 1) 90%,
				rgba(255, 255, 255, 1) 100%
			);
		}

		.delete {
			display: flex;
			position: absolute;
			top: 10px;
			right: 10px;
			width: 50px;
			height: 50px;
			z-index: 999;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		span {
			color: #46474b;
		}
	}

	@include DesktopSize {
		.container {
			gap: 20px;
			span {
				font-size: 1.25rem;
			}

			.placeholder-image {
				width: 60px;
				height: 60px;
			}

			.delete {
				width: 60px;
				height: 60px;
			}
		}
	}

</style>
